import * as angular from 'angular';

import { ItriggerActionService } from '../../services';
import { TriggerAction } from '../../models';
import { Store } from '../Store';
import * as TRIGGERACTIONS from './triggerActions.constants';

import {
    loadTriggerActions,
    loadTriggerActionsSuccess,
    deleteTriggerAction,
    deleteTriggerActionSuccess,
    addTriggerActionSuccess,
    addTriggerAction,
    updateTriggerActionSuccess
} from './triggerActions.actions';

export interface ITriggerActionActionsService {
    getAll(): (dispatch: any, getState: () => Store) => angular.IPromise<TriggerAction[]>;
    getAll(force: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<TriggerAction[]>;
    addOne(target: TriggerAction): (dispatch: any, getState: () => Store) => angular.IPromise<TriggerAction>;
    updateOne(target: TriggerAction): (dispatch: any, getState: () => Store) => angular.IPromise<TriggerAction>;
    deleteOne(target: TriggerAction): (dispatch: any, getState: () => Store) => angular.IPromise<TriggerAction>;
}

export class TriggerActionsActionsService implements ITriggerActionActionsService {

    static serviceId = 'triggerActionActionsService';
    static $inject = ['$q', 'triggerActionService'];


    constructor(
        private _$q: angular.IQService,
        private _triggerActionService: ItriggerActionService) {
    }

    getAll();
    getAll(force: boolean);
    getAll(force?: boolean) {
        return (dispatch: any, getState: () => Store) => {
            const { triggerActions } = getState();
            if (force || (!triggerActions.isLoading && !triggerActions.isLoaded)) {
                dispatch(loadTriggerActions());
                return this._triggerActionService.getAll(force)
                    .then(data => {
                        dispatch(loadTriggerActionsSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: TRIGGERACTIONS.TRIGGER_ACTIONS_LOAD_ERROR, payload: reason });
                        throw reason;
                    });
            } else {
                return this._$q.when(triggerActions.list);
            }
        };
    }

    addOne(target: TriggerAction) {
        return (dispatch: any, getState: () => Store) => {
            // const { triggerActions } = getState();
            if (target) {
                dispatch(addTriggerAction(target));
                return this._triggerActionService.addOne(target)
                    .then(data => {
                        dispatch(addTriggerActionSuccess(target));
                        return target;
                    })
                    .catch((reason) => {
                        dispatch({ type: TRIGGERACTIONS.TRIGGER_ACTION_ADD_ERROR, payload: reason });
                        throw reason;
                    });
            } else {
                return this._$q.when(null);
            }
        };
    }

    updateOne(target: TriggerAction) {
        return (dispatch: any, getState: () => Store) => {
            // const { triggerActions } = getState();
            if (target) {
                dispatch(addTriggerAction(target));
                return this._triggerActionService.updateOne(target)
                    .then(data => {
                        dispatch(updateTriggerActionSuccess(target));
                        return target;
                    })
                    .catch((reason) => {
                        dispatch({ type: TRIGGERACTIONS.TRIGGER_ACTION_UPDATE_ERROR, payload: reason });
                        throw reason;
                    });
            } else {
                return this._$q.when(null);
            }
        };
    }

    deleteOne(triggerAction: TriggerAction) {
        return (dispatch: any, getState: () => Store) => {
            // const { triggerActions } = getState();
            if (triggerAction) {
                dispatch(deleteTriggerAction(triggerAction));
                return this._triggerActionService.deleteOne(triggerAction)
                    .then(data => {
                        dispatch(deleteTriggerActionSuccess(triggerAction));
                        return triggerAction;
                    })
                    .catch((reason) => {
                        dispatch({ type: TRIGGERACTIONS.TRIGGER_ACTION_DELETE_ERROR, payload: reason });
                        throw reason;
                    });
            } else {
                return this._$q.when(null);
            }
        };
    }
}